import Modal from "react-bootstrap/Modal";
import {useState, useRef, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {SwalAlertClass} from "core/swalClass";

import axiApi from "ApiCaller";
import CustomTranslation from "core/customTranslation";
import Form from "react-bootstrap/Form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {formRefToJson} from "core/utils/formularies";
import {publishEvent} from "../../../core/eventsConnector";

const translations = {
    es: {
        title: "¿Que desea enviar?",
        description: "Seleccione el tipo de parametro que desea enviar a los dispositivos seleccionados.",
        selector: "Tipo de parametro.",
        selecteds: "Dispositivos seleccionados",
        "action.choices.c": "Configuración",
        "action.choices.c.description": "Se enviara la configuración seleccionada en los dispositivos.",
        "action.choices.b": "Batería",
        "action.choices.b.title": "Capacidad de la batería (mAh)",
        "action.choices.b.description": "Se cambiara la capacidad de la batería en mAh.",
        "action.choices.h": "Hibernación",
        "action.choices.h.description": "Se activara la hibernación de los dispositivos.",
        "action.choices.d": "Reset de fábrica",
        "action.choices.d.description":
            "Se pondran los valores por defecto en los dispositivos (salvo aquellas configuraciones que afecten a las comunicaciones).",
        "action.choices.i": "Solicitud de información",
        "info.choices.cd": "Información GPS",
        "info.choices.cd.description": "Formulario de Presets de medidas",
        "info.choices.ce": "Informacion de la configuración",
        "info.choices.ce.description": "Formulario de Presets de configuraciones",
        "info.choices.cf": "Frecuencia de transductores",
        "info.choices.cf.description": "Formulario de Presets de frecuencias",
        "action.choices.p": "Solicitud de Presets",
        "action.choices.p.description": "Se enviará la solicitud de configuración de presets de dispositivos.",

        accept: "Aceptar",
        // Mensajes adicionales
        "message.success.title": "Solicitud",
        "message.success.text": "Se han encolado las configuraciones para su envío.",
        "message.success.saved": "Se han guardado las configuraciones.",
    },
    en: {
        title: "What do you want to send?",
        description: "Select the type of parameter you want to send to the selected devices.",
        selector: "Parameter type.",
        selecteds: "Selected devices",
        "action.choices.c": "Configuration",
        "action.choices.c.description": "The selected configuration will be sent to the devices.",
        "action.choices.b": "Battery",
        "action.choices.b.description": "The battery capacity will be changed in mAh.",
        "action.choices.h": "Hibernate",
        "action.choices.h.description": "The devices will be hibernated.",
        "action.choices.d": "Default",
        "action.choices.d.description": "The devices will be set to default values.",
        "action.choices.i": "Information request",
        "info.choices.cd": "GPS information",
        "info.choices.cd.description": "Form for GPS presets",
        "info.choices.ce": "Configuration information",
        "info.choices.ce.description": "Form for configuration presets",
        "info.choices.cf": "Transducer frequency",
        "info.choices.cf.description": "Form for frequency presets",
        "action.choices.p": "Presets Request",
        "action.choices.p.description": "The request for device presets configuration will be sent.",
        accept: "Accept",
        // messages
        "message.success.title": "Request",
        "message.success.text": "The configurations will be enqueued for sending.",
        "message.success.saved": "The configurations have been saved.",
    },
};

const ActionsTypes = {
    BATTERY: "b",
    CONFIGURATION: "c",
    DEFAULT: "d",
    HIBERNATE: "h",
    INFORMATON: "i",
    PRESETS: "p",
};

const ModalSelectorSender = ({show, setShow, items}) => {
    const {t: _TC} = CustomTranslation(translations);
    const [action, setAction] = useState(ActionsTypes.CONFIGURATION);

    const formRef = useRef(null);
    const Alert = new SwalAlertClass({confirmButtonText: _TC("accept")});

    const handleChange = (event) => {
        setAction(event.target.value);
    };

    const handleClose = () => {
        setShow(false);
    };
    const onSubmit = async (e) => {
        e.preventDefault();

        let payload = formRefToJson(formRef.current);
        payload.chosen = items.current.items.map((item) => item.uuid);

        const resp = await axiApi.post("/api/devices/networks/send/", payload);
        if (resp.data) {
            setShow(false);
            Alert.success(_TC("message.success.title"), _TC("message.success.text")).then((resp) => {
                publishEvent("reload:view:sender", {});
            });
        }
    };

    const getParams = () => {
        switch (action) {
            case ActionsTypes.BATTERY:
                return (
                    <div className="col-12">
                        <h5>{_TC("action.choices.b.description")}</h5>
                        <div className="form-group">
                            <label htmlFor="battery">{_TC("action.choices.b")}</label>
                            <input
                                type="number"
                                className="form-control text-end"
                                id="battery"
                                name="battery"
                                placeholder="mAh"
                                min="0"
                                max="19000"
                                required
                                style={{width: "120px"}}
                            />
                        </div>
                    </div>
                );
            case ActionsTypes.HIBERNATE:
                return <h5>{_TC("action.choices.h.description")}</h5>;
            case ActionsTypes.DEFAULT:
                return <h5>{_TC("action.choices.d.description")}</h5>;
            case ActionsTypes.INFORMATON:
                return (
                    <div className="col-12">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="info-mode"
                                id="info-mode-cd"
                                defaultValue="cd"
                                defaultChecked={true}
                            />
                            <label className="form-check-label" htmlFor="info-mode-cd">
                                {_TC("info.choices.cd")}
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="info-mode"
                                id="info-mode-ce"
                                defaultValue="ce"
                                defaultChecked={false}
                            />
                            <label className="form-check-label" htmlFor="info-mode-ce">
                                {_TC("info.choices.ce")}
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="info-mode"
                                id="info-mode-cf"
                                defaultValue="cf"
                                defaultChecked={false}
                            />
                            <label className="form-check-label" htmlFor="info-mode-cf">
                                {_TC("info.choices.cf")}
                            </label>
                        </div>
                    </div>
                );
            case ActionsTypes.PRESETS:
                return (
                    <div className="col-12">
                        {/* <h5>{_TC("action.choices.p.description")}</h5> */}
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="preset-mode"
                                id="preset-mode-dd01"
                                value="dd01"
                                defaultChecked={true}
                            />
                            <label className="form-check-label" htmlFor="preset-mode-dd01">
                                {_TC("info.choices.cd.description")} <strong>01</strong>
                            </label>
                        </div>
                    </div>
                );
        }
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} aria-modal={true} centered>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="fa-regular fa-paper-plane" />
                    </div>
                    <div className="preview-title d-inline-flex align-items-center">
                        <Modal.Title>{_TC("title")}</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={(e) => e.preventDefault()} ref={formRef}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <p>{_TC("description")}</p>
                                    <h5>
                                        {_TC("selecteds")}: {items.current.items?.length || "-"}
                                    </h5>
                                    <div className="form-group mt-4">
                                        <label htmlFor="action">{_TC("selector")}</label>
                                        <select
                                            className="form-control"
                                            id="action"
                                            name="action"
                                            onChange={handleChange}
                                            value={action}>
                                            <option value={ActionsTypes.CONFIGURATION}>{_TC("action.choices.c")}</option>
                                            <option value={ActionsTypes.BATTERY}>{_TC("action.choices.b")}</option>
                                            <option value={ActionsTypes.HIBERNATE}>{_TC("action.choices.h")}</option>
                                            <option value={ActionsTypes.DEFAULT}>{_TC("action.choices.d")}</option>
                                            <option value={ActionsTypes.INFORMATON}>{_TC("action.choices.i")}</option>
                                            <option value={ActionsTypes.PRESETS}>{_TC("action.choices.p")}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row my-4">{getParams()}</div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={onSubmit}>
                        Enviar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalSelectorSender;
